import React from 'react'
import './writing.css'
import WriteContainer from '../components/WriteContainer'
import Stars from '../components/Stars';

function writing() {

  return (
    <>
    <Stars/>
    <div className='container'>
      <h1 className='title'>WRITING</h1>
      <WriteContainer/>
    </div>
    </>
  )
}

export default writing